import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Group} from '../../../../../models/group.model';
import {FullUser} from '../../../../../models/full-user.model';
import {GroupUser} from '../../../../../models/group-user.model';
import {AdminService} from '../../../../../services/admin.service';
import { User } from '../../../../../models/user.model';
import { UserService } from '../../../../../services/user.service';

@Component({
  selector: 'app-set-head-deputy',
  templateUrl: './set-head-deputy.component.html',
  styleUrls: ['./set-head-deputy.component.css']
})
export class SetHeadDeputyComponent implements OnInit {
  public group: Group;
  public selectedHead: FullUser;
  public selectedDeputy: FullUser;
  public activeUsers: GroupUser[];
  public users: FullUser[] = [];
  public isLoaded = false;
  public errorInfo = false;
  public successInfo = false;
  public noSelected = false;
  user: User;
	isAdmin = false;
	isHeadOfGroup = false;
	isUser = false;
	isDeputy = false;

  constructor(public activeModal: NgbActiveModal,
              public adminService: AdminService,
              public userService: UserService) {
  }

  public showHeadFields = true;

  ngOnInit() {
    this.activeUsers = this.group.activeUsers;
    for (const activeUser of this.activeUsers) {
      this.users.push(activeUser.user);
    }
    this.selectedHead = this.group.head;
    this.selectedDeputy = this.group.deputy;
    this.isLoaded = true;
    this.user = this.userService.getLocal();
		if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHeadOfGroup = true;
		} else {
			this.isHeadOfGroup = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		}
  }

  setShowHeadFields(value: boolean) {
    this.showHeadFields = value;
  }

  setGroup(group: Group) {
    this.group = group;
  }

  selectedH(user: FullUser) {
    this.selectedHead = user;
  }

  selectedD(user: FullUser) {
    this.selectedDeputy = user;
  }

  setHeadDeputy() {
    if (this.selectedDeputy === null || this.selectedHead === null) {
      this.noSelected = true;
    } else {
      this.isLoaded = false;
      this.adminService.setHeadsForGroup(this.group.id, this.selectedHead.id, this.selectedDeputy.id).subscribe(
        (response) => {
          if (response.status === 200) {
            this.group.deputy = this.selectedDeputy;
            this.group.head = this.selectedHead;
            this.successInfo = true;
            this.errorInfo = false;
            this.noSelected = false;
            this.isLoaded = true;
          }
        },
        () => {
          this.successInfo = false;
          this.noSelected = false;
          this.errorInfo = true;
          this.isLoaded = true;
        });
    }
  }

  filterBy(prop: string) {
    if (this.users !== undefined) {
      return this.users.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
    }
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-group/popups/set-head-deputy/set-head-deputy.component.ts